type NamedUser =
  | {
      id?: string | null;
      name?: string | null;
    }
  | null
  | undefined;

/** True when the person has no usable name (guest / anonymous). */
export function isUnnamedSubmitter(user?: NamedUser): boolean {
  return !user?.name?.trim();
}

export function namedSubmitterInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter((part) => part && part !== '·')
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
